// src/components/ImportDataList/TabPanel.js
import React from 'react';
import Box from '@mui/material/Box';

const TabPanel = ({ children, value, index, ...other }) => (
  <div role="tabpanel" hidden={value !== index} {...other}>
    {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
  </div>
);

export default TabPanel;